import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import React, { useContext, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FormFileUploader } from '../../../../components/form/FormFileUploader';
import { FormInput } from '../../../../components/form/FormInput';
import { FormInputLabel } from '../../../../components/form/FormInputLabel';
import { ModalCreditAssignee } from '../../../../components/modal/CreditAssignee';
import { UserContext } from '../../../../contexts';
import { useLabel } from '../../../../hooks';
import { modalStyle } from '../../../../styles/style';
import { CommonCreditFields } from '../components/CommonCreditFields';
import { creditFormInitialValues } from '../form';

export const MoveForm = ({
  control,
  errors,
  register,
  selectMenus,
  reasonMenus,
  watch,
  selectedMenu,
  validations,
  setValue,
}) => {
  const { t } = useTranslation();
  const { userInfo } = useContext(UserContext);
  const { BUTTON } = useLabel();
  const fileRef = useRef(null);
  const [open, setOpen] = useState(false);
  const initialValues = creditFormInitialValues.move;

  const onAssigneeClick = (item) => {
    /* 양도 */
    setValue('assignorUserSeq', userInfo.seq);
    setValue('assignorUserCompanyName', userInfo.companyName);
    setValue('assignorUserName', userInfo.ceoName);

    /* 양수 */
    setValue('assigneeUserSeq', item.seq);
    setValue('assigneeUserCompanyName', item.companyName);
  };

  return (
    <div className='flex flex-col gap-4'>
      <div className='grid grid-cols-2 gap-8'>
        <div>
          <h3 className='text-lg font-semibold mb-2'>{t('TRANSFERER_INFO')}</h3>
          <div className='flex flex-col gap-8'>
            <FormInput
              label={t('RESPONSIBILITY')}
              required
              {...register('assignorName', validations?.assignorName || { required: true })}
              error={errors.assignorName}
              defaultValue={initialValues.assignorName}
            />
            <FormInput
              label={t('CONTACT_MOBILE')}
              required
              {...register('assignorPhone', validations?.assignorPhone || { required: true })}
              error={errors.assignorPhone}
              defaultValue={initialValues.assignorPhone}
            />
            <FormInput
              label={t('DEPARTMENT')}
              {...register('assignorTeam')}
              error={errors.assignorTeam}
              defaultValue={initialValues.assignorTeam}
            />
            <FormInput
              label={t('RESPONSIBILITY_EMAIL')}
              type='email'
              required
              {...register('assignorEmail', validations?.assignorEmail || { required: true })}
              error={errors.assignorEmail}
              defaultValue={initialValues.assignorEmail}
            />
          </div>
        </div>
        <div>
          <h3 className='text-lg font-semibold mb-2'>{t('TRANSTEREE_INFO')}</h3>
          <div className='flex flex-col gap-8'>
            <div className='flex items-end gap-2 flex-1'>
              <FormInput
                label={t('ASSIGNEE_USER')}
                required
                {...register('assigneeUserCompanyName', validations?.assigneeUserSeq || { required: true })}
                error={errors.assigneeUserSeq}
                defaultValue={initialValues.assigneeName}
                inputProps={{
                  readOnly: true,
                }}
              />
              <Button
                variant='outlined'
                sx={{
                  height: '56px',
                  borderRadius: '10px',
                }}
                onClick={() => {
                  setOpen(true);
                }}
              >
                {t('SEARCH')}
              </Button>
            </div>
            <FormInput
              label={t('RESPONSIBILITY')}
              required
              {...register('assigneeName', validations?.assigneeName || { required: true })}
              error={errors.assigneeName}
              defaultValue={initialValues.assigneeName}
            />
            <FormInput
              label={t('CONTACT_MOBILE')}
              required
              {...register('assigneePhone', validations?.assigneePhone || { required: true })}
              error={errors.assigneePhone}
              defaultValue={initialValues.assigneePhone}
            />
            <FormInput
              label={t('DEPARTMENT')}
              {...register('assigneeTeam')}
              error={errors.assigneeTeam}
              defaultValue={initialValues.assigneeTeam}
            />
            <FormInput
              label={t('RESPONSIBILITY_EMAIL')}
              type='email'
              required
              {...register('assigneeEmail', validations?.assigneeEmail || { required: true })}
              error={errors.assigneeEmail}
              defaultValue={initialValues.assigneeEmail}
            />
          </div>
        </div>
      </div>
      <div className='pt-10 mt-10 border-t border-solid border-gray-300'>
        <h3 className='text-lg font-semibold mb-2'>{t('CREDIT_TRANSFER_INFO')}</h3>
        <CommonCreditFields
          type={'move'}
          control={control}
          errors={errors}
          register={register}
          watch={watch}
          selectMenus={selectMenus}
          selectedMenu={selectedMenu}
          reasonMenus={reasonMenus}
          showProjectSeq={true}
          showAmount={true}
          showReasonDetail={true}
          reasonDetailLabel={t('CREDIT_TRANSFER_REASON_DETAIL')}
          reasonDetailFieldName='reasonDetail'
          validations={validations}
        />
        <div className='flex flex-col gap-1 mt-4'>
          <FormInputLabel label={t('FILE')} />
          <FormFileUploader name='files' control={control} multiple accept='*/*' ref={fileRef}>
            {watch('files')?.length > 0 &&
              watch('files')?.map((file) => (
                <div key={file.name} className='py-2'>
                  <a
                    href={file.url}
                    className='text-blue-500 underline cursor-pointer'
                    download
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    {typeof file === 'string' ? file : file?.name}
                  </a>
                </div>
              ))}
            <div
              className='border border-solid border-gray-300 p-4 mt-4 text-center rounded-md cursor-pointer'
              onClick={() => {
                fileRef.current?.click();
              }}
            >
              <span>{BUTTON.ADD_FILES}</span>
            </div>
          </FormFileUploader>
        </div>
      </div>
      <Modal
        open={open}
        onClose={() => {
          setOpen(false);
        }}
      >
        <Box sx={modalStyle}>
          <ModalCreditAssignee
            onClose={() => {
              setOpen(false);
            }}
            onClick={(item) => {
              setOpen(false);

              console.log('item -----> onAssigneeClick', item);
              onAssigneeClick(item);
            }}
          ></ModalCreditAssignee>
        </Box>
      </Modal>
    </div>
  );
};
